export const SELECT_MIN_WIDTH = 156;
export const SELECT_MAX_WIDTH = 240;

export const AnalyticsFieldTypes = {
	DEFAULT: 'DEFAULT',
	SHORT_TEXT: 'SHORT_TEXT',
};
